const ToolboxInfo = {
  maxInstances: { character_motion_move: 3 },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "character_motion_move",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
